import { LanguageContent, LanguageObject } from './content';
import { useAppLanguage } from './useAppLanguage';

// Work by ChatGPT. If somebody really knows typescript or if AI becomes a bit smarter, please rework this ;)
type First<T extends any[]> = T extends [infer F, ...any[]] ? F : never;
type Rest<T extends any[]> = T extends [any, ...infer R] ? R : never;
type Merge<T extends any[]> = T extends [] ? {} : First<T> & Merge<Rest<T>>;

export function useContent<T extends LanguageContent[]>(
  ...contents: { [K in keyof T]: LanguageObject<T[K]> }
): Merge<T> {
  const language = useAppLanguage();
  if (contents.every(c => Array.isArray(c[language])))
    return contents.flatMap(content => content[language]) as Merge<T>;

  return Object.assign(
    {},
    ...contents.map(content => content[language]),
  ) as Merge<T>;
}
